import { useEffect, useRef } from 'react';
import type { NavigateOptions } from 'react-router-dom';

import type {
  HandleLoginOptions,
  SignupScreen,
} from '../CreateAccountFormContext';

type UseSignupUrlParamsOptions = {
  screen: SignupScreen;
  searchParams: URLSearchParams;
  setSearchParams: (
    params: URLSearchParams,
    navigateOpts?: NavigateOptions,
  ) => void;
  handleLogin: (opts?: HandleLoginOptions) => Promise<void>;
};

export const useSignupUrlParams = ({
  screen,
  searchParams,
  setSearchParams,
  handleLogin,
}: UseSignupUrlParamsOptions): void => {
  const hasCleanedStepParamRef = useRef(false);
  useEffect(() => {
    if (hasCleanedStepParamRef.current || !searchParams.has('step')) return;
    hasCleanedStepParamRef.current = true;
    const params = new URLSearchParams(searchParams);
    params.delete('step');
    setSearchParams(params, { replace: true });
  }, [searchParams, setSearchParams]);

  const autoLoginTriggeredRef = useRef(false);
  useEffect(() => {
    if (
      autoLoginTriggeredRef.current ||
      screen !== 'welcome' ||
      !searchParams.has('verified')
    ) {
      return;
    }

    autoLoginTriggeredRef.current = true;
    const params = new URLSearchParams(searchParams);
    params.delete('verified');

    setSearchParams(params, { replace: true });
    void handleLogin({ trigger: 'automatic', silent: true });
  }, [screen, searchParams, setSearchParams, handleLogin]);
};
